import React from 'react';
import { Outlet } from 'react-router';
import { DashboardLayout, PageContent } from '../layouts/DashboardLayout';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

function MainApp() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <DashboardLayout>
                <PageContent>
                    <Outlet />
                </PageContent>
            </DashboardLayout>
        </QueryClientProvider>
    );
}

export default MainApp;
